import React from "react";
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  Alert,
  InputGroup,
  InputGroupAddon,
  Badge,
} from "reactstrap";

import isEqual from "lodash.isequal";
import ReactJson from "react-json-view";
import * as Extensions from "trimble-connect-project-workspace-api";

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainMenu: {
        title: "Test React app",
        icon: `https://components.stage.connect.trimble.com/trimble-connect-project-workspace-api/logo192.png`,
        command: "main_nav_menu_cliked",
      },
      subMenuItems: [
        {
          title: "Sub menu 1",
          icon: `https://components.stage.connect.trimble.com/trimble-connect-project-workspace-api/logo192.png`,
          command: "submenu_1_clicked",
        },
        {
          title: "Sub menu 2",
          icon: `https://components.stage.connect.trimble.com/trimble-connect-project-workspace-api/logo192.png`,
          command: "submenu_2_clicked",
        },
      ],
      queryParams: "?taskId=16&navigate=true",
      editParams: false,
    };
  }

  async componentDidMount() {
    const { mainMenu, subMenuItems = [] } = this.state;
    if (inIframe()) {
      this.API = await Extensions.connect(
        window.parent,
        (event, args) => {
          switch (event) {
            case "extension.command":
              this.setState({
                alertMessage: `Command executed by the user {command:${args.data}}`,
              });
              break;
            case "extension.accessToken":
              this.setState({ accessToken: args.data });
              break;
            case "extension.userSettingsChanged":
              this.setState({ alertMessage: `User settings changed!` });
              this.getUserSettings();
              break;
            default:
          }
        },
        30000
      );

      this.API.ui.setMenu({ ...mainMenu, subMenus: [...subMenuItems] }).then();

      //requesting accessToken after 5 secs
      // setTimeout(() => {
      //   this.API.extension.getPermission("accesstoken").then(permission => console.log("extension:react-client:getPermission", permission));
      // }, 5000);
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    if (
      !isEqual(this.state.subMenuItems, prevState.subMenuItems) ||
      !isEqual(this.state.mainMenu, prevState.mainMenu)
    ) {
      const { mainMenu, subMenuItems = [] } = this.state;
      if (!mainMenu) return;
      const menuObject = {
        ...mainMenu,
        subMenus: [...subMenuItems],
      };
      if (this.API) {
        this.API.ui.setMenu(menuObject);
      }
    }

    if (this.state.activeCommand !== prevState.activeCommand) {
      if (!this.state.activeCommand) return;
      if (this.API) {
        this.API.ui.setActiveMenuItem(this.state.activeCommand);
      }
    }
  }

  setActiveCommand = (e, command) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ activeCommand: command });
  };

  removeSubmenu = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const newSubmentItems = [...this.state.subMenuItems];
    newSubmentItems.splice(index, 1);
    this.setState({ subMenuItems: [...newSubmentItems] });
  };

  toggle = () => this.setState({ modal: !this.state.modal });

  editSubmenu = (e, i) => {
    e.preventDefault();
    e.stopPropagation();
    const formData = { ...this.state.subMenuItems[i] };
    this.setState({
      modal: true,
      editMenu: "subMenuItems",
      editIndex: i,
      formData,
    });
  };

  editMainMenu = () => {
    const formData = { ...this.state.mainMenu };
    this.setState({ modal: true, editMenu: "mainMenu", formData });
  };

  onChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  addSubMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.onCancel();
    this.setState({
      modal: true,
      formData: { title: "", icon: "", command: "" },
    });
  };

  onSave = () => {
    const { formData, editMenu, editIndex = 0, subMenuItems = [] } = this.state;
    if (!formData) return;
    if (editMenu === "mainMenu") {
      this.setState({ mainMenu: { ...formData } });
    } else if (editMenu === "subMenuItems") {
      if (subMenuItems.length === 0) return;
      const newSubMenuItems = subMenuItems.map((sm, i) =>
        i === editIndex ? { ...formData } : sm
      );
      this.setState({ subMenuItems: [...newSubMenuItems] });
    } else {
      this.setState({ subMenuItems: [...subMenuItems, { ...formData }] });
    }
    this.onCancel();
  };

  onCancel = () => {
    this.setState({
      modal: false,
      editMenu: undefined,
      formData: undefined,
      editIndex: undefined,
    });
  };

  updateStatus = () => {
    const { statusMessage = "" } = this.state;
    if (this.API) {
      this.API.extension.setStatusMessage(statusMessage);
    }
  };

  getProjectDetails = () => {
    if (this.API) {
      this.API.project
        .getCurrentProject()
        .then((projectInfo) => this.setState({ projectInfo }));
    }
  };

  getUserSettings = () => {
    if (this.API) {
      this.API.user
        .getUserSettings()
        .then((userSettings) => this.setState({ userSettings }));
    }
  };

  getAccessToken = () => {
    if (this.API) {
      this.API.extension
        .getPermission("accesstoken")
        .then((accessToken) => this.setState({ accessToken }));
    }
  };

  goTo = (routeKey = "settings-extensions") => {
    if (this.API) {
      this.API.extension.goTo(routeKey);
    }
  };

  render() {
    const {
      mainMenu,
      subMenuItems = [],
      activeCommand,
      modal = false,
      formData = {},
      alertMessage,
      statusMessage = "",
      projectInfo = {},
      userSettings = {},
      accessToken = "",
    } = this.state;
    return (
      <Container>
        {/** extension.setMenu, extension.setActiveMenuItem*/}
        <Row className="section">
          {alertMessage && (
            <Col md="12">
              <Alert
                color="success"
                isOpen={!!alertMessage}
                toggle={() => this.setState({ alertMessage: undefined })}
                fade={false}
              >
                {alertMessage}
              </Alert>
            </Col>
          )}
          <Col md="12">
            <h3>
              Example: <i>ui.setMenu</i> & <i>ui.setActiveMenuItem</i>
            </h3>
            <p>
              Dynamically manage the submenu items. (<strong>Menu Title</strong>
              :<i>command</i>){" "}
              <Button
                color="primary"
                size="sm"
                style={{ marginLeft: "2rem" }}
                onClick={this.addSubMenu}
              >
                Add sub-menu
              </Button>
            </p>
          </Col>
          <Col md="12">
            <ListGroup>
              <ListGroupItem tag="div" className="menu-item">
                <div>
                  {mainMenu.icon && (
                    <img src={mainMenu.icon} className="sml-img" alt="" />
                  )}
                  <strong>{mainMenu.title}</strong>:<i>{mainMenu.command}</i>
                  <Button
                    color="info"
                    size="sm"
                    style={{ marginLeft: "2rem" }}
                    onClick={this.editMainMenu}
                  >
                    Edit
                  </Button>
                </div>
                <div>Main-menu</div>
              </ListGroupItem>
              {subMenuItems.map((sm, i) => (
                <ListGroupItem
                  key={sm.command}
                  tag="a"
                  href="#"
                  className="menu-item submenu"
                  active={activeCommand && activeCommand === sm.command}
                  onClick={(e) => this.setActiveCommand(e, sm.command)}
                >
                  <div>
                    {sm.icon && (
                      <img src={sm.icon} className="sml-img" alt="" />
                    )}
                    <strong>{sm.title}</strong>:<i>{sm.command}</i>{" "}
                    <Button
                      color="info"
                      size="sm"
                      style={{ marginLeft: "2rem" }}
                      onClick={(e) => this.editSubmenu(e, i)}
                    >
                      Edit
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      style={{ marginLeft: "2rem" }}
                      onClick={(e) => this.removeSubmenu(e, i)}
                    >
                      Remove
                    </Button>
                  </div>
                  <div>Sub-menu</div>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>
        </Row>

        {/** extension.setActiveMenuItem with query params*/}
        <Row>
          <Col md="12">
            <h3>
              Example: <i>ui.setActiveMenuItem</i> with query param support
            </h3>
            <p>
              ui.setActiveMenuItem will be triggered with the following query
              param.{" "}
            </p>
            <p>
              {!this.state.editParams && (
                <>
                  <Button outline color="primary" size="sm" className="mx-2">
                    {this.state.queryParams}
                  </Button>
                  <Button
                    outline
                    color="info"
                    size="sm"
                    onClick={() => this.setState({ editParams: true })}
                  >
                    edit
                  </Button>
                </>
              )}{" "}
              {this.state.editParams && (
                <Input
                  value={this.state.queryParams}
                  onChange={(e) => {
                    this.setState({
                      queryParams: e.target.value,
                    });
                  }}
                  onBlur={() => this.setState({ editParams: false })}
                />
              )}
            </p>
            <p>
              {this.state.subMenuItems.map((item) => (
                <Button
                  key={item.command + "_query"}
                  color="primary"
                  onClick={() =>
                    this.setState({
                      activeCommand: item.command + this.state.queryParams,
                    })
                  }
                  className={"mx-2"}
                >
                  {item.title}
                </Button>
              ))}
            </p>
          </Col>
        </Row>

        {/** extension.setStatusMessage*/}
        <Row className="section">
          <Col md="12">
            <h3>
              Example: <i>extension.setStatusMessage</i>
            </h3>
            <p>Dynamically update the extension status message.</p>
          </Col>
          <Col md="12">
            <InputGroup>
              <Input
                onChange={(e) =>
                  this.setState({ statusMessage: e.target.value })
                }
                value={statusMessage}
              />
              <InputGroupAddon addonType="append">
                <Button color="primary" onClick={this.updateStatus}>
                  Update
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </Col>
        </Row>

        {/** extension.getCurrentProject*/}
        <Row className="section">
          <Col md="12">
            <h3>
              Example: <i>project.getCurrentProject</i>
            </h3>
            <p>
              Get the current project details.{" "}
              <Button
                color="primary"
                size="sm"
                style={{ marginLeft: "2rem" }}
                onClick={this.getProjectDetails}
              >
                Get Project
              </Button>
            </p>
          </Col>
          <Col md="12">
            <ReactJson src={projectInfo} />
          </Col>
        </Row>

        {/** extension.getUserSettings*/}
        <Row className="section">
          <Col md="12">
            <h3>
              Example: <i>user.getUserSettings</i>
            </h3>
            <p>
              Get the current user settings details.{" "}
              <Button
                color="primary"
                size="sm"
                style={{ marginLeft: "2rem" }}
                onClick={this.getUserSettings}
              >
                Get User Settings
              </Button>
            </p>
          </Col>
          <Col md="12">
            <Form>
              {Object.keys(userSettings).map((field) => {
                const value = userSettings[field];
                return (
                  <FormGroup row key={field} style={{ marginBottom: "1rem" }}>
                    <Label for={field} sm={2} className="capz">
                      {field}
                    </Label>
                    <Col sm={10}>
                      <Input
                        type="text"
                        name={field}
                        id={field}
                        value={value}
                        readOnly
                      />
                    </Col>
                  </FormGroup>
                );
              })}
            </Form>
          </Col>
        </Row>

        {/** extension.getPermission*/}
        <Row className="section">
          <Col md="12">
            <h3>
              Example: <i>extension.getPermission</i>
            </h3>
            <p>
              Request the accessToken.{" "}
              <Button
                color="primary"
                size="sm"
                style={{ marginLeft: "2rem" }}
                onClick={this.getAccessToken}
              >
                Get accessToken
              </Button>
            </p>
          </Col>
          <Col md="12">
            <Form>
              <FormGroup row style={{ marginBottom: "1rem" }}>
                <Label for={"accessToken"} sm={2} className="capz">
                  {"AccessToken"}
                </Label>
                <Col sm={10}>
                  <Input
                    type="text"
                    name={"accessToken"}
                    id={"accessToken"}
                    value={accessToken}
                    readOnly
                  />
                </Col>
              </FormGroup>
            </Form>
          </Col>
        </Row>

        {/** extension.goTo*/}
        <Row className="section">
          <Col md="12">
            <h3>
              Example: <i>extension.goTo</i>
            </h3>
            <p>
              Go to a specific route/page.{" "}
              <Button
                color="primary"
                size="sm"
                style={{ marginLeft: "2rem" }}
                onClick={() => this.goTo()}
              >
                Click here
              </Button>
            </p>
            <p>
              Go to the project settings page.{" "}
              <Button
                color="primary"
                size="sm"
                style={{ marginLeft: "2rem" }}
                onClick={() => this.goTo("settings-details")}
              >
                Click here
              </Button>
            </p>
          </Col>
        </Row>

        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal-header">
            <h5 className="modal-title">Modal title</h5>
          </div>
          <ModalBody>
            <Form>
              {Object.keys(formData).map((field) => {
                const value = formData[field];
                return (
                  <FormGroup row key={field} style={{ marginBottom: "1rem" }}>
                    <Label for={field} sm={2} className="capz">
                      {field}
                    </Label>
                    <Col sm={10}>
                      <Input
                        type="text"
                        name={field}
                        id={field}
                        placeholder={`Enter ${field}`}
                        value={value}
                        onChange={this.onChange}
                      />
                    </Col>
                  </FormGroup>
                );
              })}
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onSave}>
              Submit
            </Button>{" "}
            <Button color="secondary" onClick={this.onCancel}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  }
}

export default App;
